export const MEETING_LIFECYCLE = {
  NONE: 'none',
  FUTURE: 'future',
  ONGOING: 'ongoing',
};

const parseDate = value => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const resolveMeetingLifecycle = (contact = {}, now = Date.now()) => {
  const serverState = contact.meeting_lifecycle;
  if (
    serverState === MEETING_LIFECYCLE.NONE ||
    serverState === MEETING_LIFECYCLE.FUTURE ||
    serverState === MEETING_LIFECYCLE.ONGOING
  ) {
    return serverState;
  }

  const start = parseDate(contact.meeting_starts_at);
  if (!start) return MEETING_LIFECYCLE.NONE;

  if (start.getTime() > now) return MEETING_LIFECYCLE.FUTURE;

  const end = parseDate(contact.meeting_ends_at);
  if (!end || end.getTime() > now) return MEETING_LIFECYCLE.ONGOING;

  return MEETING_LIFECYCLE.NONE;
};

export const canBookMeeting = (contact, now) =>
  resolveMeetingLifecycle(contact, now) === MEETING_LIFECYCLE.NONE;

const isCurrentOrFutureMeeting = (contact, now) => {
  const state = resolveMeetingLifecycle(contact, now);
  return state === MEETING_LIFECYCLE.FUTURE || state === MEETING_LIFECYCLE.ONGOING;
};

export const canRescheduleMeeting = (contact, now) =>
  contact?.can_reschedule_meeting === true || isCurrentOrFutureMeeting(contact, now);

export const canCancelMeeting = (contact, now) =>
  contact?.can_cancel_meeting === true || isCurrentOrFutureMeeting(contact, now);

export const isMeetingOngoing = (contact, now) =>
  resolveMeetingLifecycle(contact, now) === MEETING_LIFECYCLE.ONGOING;
